import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TextInput from "@shared/v2/TextInput";
import Button from "@shared/v2/Button";
import FieldLabel from "@shared/v2/FieldLabel";
import RadioButton from "@shared/v2/RadioButton";

const ExpenseFinder = ({ accountId, setTransactionResults }) => {
  const [email, setEmail] = useState("");
  const [forBrokerageCap, setForBrokerageCap] = useState(true);
  const [slug, setSlug] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .get(`/support/accounts/${accountId}/list_transaction_financials`, {
        params: { email, forBrokerageCap, slug },
      })
      .then((res) => {
        setLoading(false);
        setTransactionResults(res.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <form className="tw-flex tw-flex-col tw-gap-[24px]" onSubmit={handleSubmit}>
      <div className="tw-flex tw-gap-[16px]">
        <TextInput
          containerClassName="tw-flex-1"
          label="Login User Email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextInput
          containerClassName="tw-flex-1"
          label="Listing Slug"
          name="slug"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
        />
      </div>
      <div>
        <FieldLabel label="Issue with:" />
        <div className="tw-flex tw-gap-[16px]">
          <RadioButton
            label="Brokerage Split Amounts"
            checked={forBrokerageCap}
            onClick={() => setForBrokerageCap(true)}
          />
          <RadioButton
            label="Royalty Amounts"
            checked={!forBrokerageCap}
            onClick={() => setForBrokerageCap(false)}
          />
        </div>
      </div>
      <div>
        <Button size="medium" isLoading={loading} type="submit">
          Submit
        </Button>
      </div>
    </form>
  );
};

ExpenseFinder.propTypes = {
  accountId: PropTypes.string.isRequired,
  setTransactionResults: PropTypes.func.isRequired,
};

export default ExpenseFinder;
